import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Fill-only outline of the regridded 16px Octicons CheckIcon at the approved weight.
export const ReviewApprovedIcon: Icon = props => (
  <CustomIcon {...props} naturalWidth={12} naturalHeight={12}>
    <path d="M9.79 4.477 5.257 9.008a.72.72 0 0 1-.504.21.72.72 0 0 1-.511-.21L2.21 6.978l-.006-.006a.72.72 0 0 1-.193-.488.72.72 0 0 1 .21-.51.25.25 0 0 1 .323-.027L4.723 7.51l.184-.183.307-.306.284-.281.389-.383.345-.338.356-.346.331-.319.305-.29.262-.246.225-.209.195-.177.247-.222.2-.173.205-.174.164-.13.17-.13a3 3 0 0 1 .153-.104 2 2 0 0 1 .146-.084 1 1 0 0 1 .145-.06.5.5 0 0 1 .15-.025.4.4 0 0 1 .12.016l.01.003a.43.43 0 0 1 .177.115.72.72 0 0 1 .207.5.72.72 0 0 1-.21.511Z" />
  </CustomIcon>
)
